import axios from "axios";
import useSWR, { mutate } from "swr";
import { fetchIfAuth, basicFetcher } from "utils/fetcher";
import useSWRMutation from "swr/mutation";
import { formatPhoneNumber } from "utils/formatPhoneNumber";

export default function useUser() {
  return useSWR<User>("auth/users/me/", fetchIfAuth, {
    errorRetryCount: 0,
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  });
}

export function useUserFetch() {
  return useSWR<User>("auth/users/me/", basicFetcher, {
    isPaused() {
      return !axios.defaults.headers.common.Authorization;
    },
    errorRetryCount: 0,
    shouldRetryOnError: false,
  });
}

export const useAuth = useUser as () => ReturnType<typeof useUser> & {
  data: User;
};

export function useGoogleAuth() {
  return useSWRMutation(
    "auth/google/",
    async (
      url,
      {
        arg,
      }: {
        arg: {
          auth_token: string;
        };
      }
    ) => {
      const { data } = await axios.post(url, arg);
      return data as User;
    },
    {
      onSuccess(data) {
        localStorage.setItem("imprt", data.refresh);
        axios.defaults.headers.common["Authorization"] = "Bearer " + data.access;
        mutate("auth/users/me/", data);
      },
    }
  );
}

export function useVendorSignup() {
  return useSWRMutation(
    "auth/users/vendor",
    async (
      url,
      {
        arg,
      }: {
        arg: Record<string, any>;
      }
    ) => {
      if (arg.vendor_data.phone) {
        arg.vendor_data.phone = formatPhoneNumber(arg.vendor_data.phone);
      }

      if (arg.bank_detail.phone) {
        arg.bank_detail.phone = formatPhoneNumber(arg.bank_detail.phone);
      }

      const { data } = await axios.post(url, arg);
      return data as User;
    }
  );
}

export function useOTPNew() {
  return useSWRMutation(
    "auth/otp/new/",
    async (
      url,
      {
        arg,
      }: {
        arg: Record<string, string>;
      }
    ) => {
      const { data } = await axios.post(url, arg);
      return data;
    }
  );
}

export function useImageUpload() {
  return useSWRMutation(
    "auth/users/me/",
    async (
      _,
      {
        arg,
      }: {
        arg: Record<string, string | File>;
      }
    ) => {
      const { data } = await axios.post("auth/image-upload", arg);
      return data;
    }
  );
}
